import { gql } from "apollo-angular";

export const CREATE_EESE_COVERAGE_MUTATION = gql`mutation configuratorCreateEeseCoverage($EeseCoverage: EeseCoverageInput) {
  configuratorCreateEeseCoverage(EeseCoverage: $EeseCoverage) {
    responseMessages
    returnValue
    success
  }
}
`

export const UPDATE_EESE_COVERAGE_MUTATION = gql`mutation configuratorUpdateEeseCoverage($EeseCoverage: EeseCoverageInput) {
  configuratorUpdateEeseCoverage(EeseCoverage: $EeseCoverage) {
    responseMessages
    returnValue
    success
  }
}
`

export const DELETE_EESE_COVERAGE_MUTATION = gql`mutation configuratorDeleteEeseCoverage($Uid: String!) {
  configuratorDeleteEeseCoverage(Uid: $Uid)
}
`
